import { Injectable } from '@angular/core';
import { ApiServiceBase } from '@api/abstracts';
import { PhysicalVendor, PhysicalVendorListResponseSchema } from '@api/models/dashboard';
import { environment } from '@environments/environment';
import { from, map, Observable } from 'rxjs';

/**
 * Physical-store vendors (subscription model).
 * Admin API: GET /stores/{storeId}/vendors/physical (base already includes /api/v1).
 */
@Injectable({
  providedIn: 'root',
})
export class PhysicalVendorsData extends ApiServiceBase<PhysicalVendor> {
  constructor() {
    super('stores', 'evoqAdmin');
  }

  fetchPhysicalVendors(storeId: string): Observable<PhysicalVendor[]> {
    if (environment.isMockEnabled) {
      return from(import('@mock/schema/dashboard/physical-team.mock')).pipe(
        map((mock) => mock.listPhysicalVendorsMock())
      );
    }

    // Each vendor carries its subscription state: activeSubscription, subscriptionExpirationDate
    // (null unless a cancellation is scheduled) and freeImageBalance (free credits when unsubscribed).
    return this.customRequest<unknown>({ method: 'GET', url: `${storeId}/vendors/physical` }).pipe(
      map((response) => {
        const result = PhysicalVendorListResponseSchema.safeParse(response);
        if (!result.success) {
          throw new Error('Invalid physical vendors response');
        }
        return result.data;
      })
    );
  }
}
